const UploadIcon = ({ width = 13, height = 14 }): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.5V2.125H13V0.5H0ZM6.5 3.75L1.625 8.625H4.875V13.5H8.125V8.625H11.375L6.5 3.75Z" fill="white" />
    </svg>
  )
}

export default UploadIcon
